import styled from 'styled-components'

export const PaginationWrapper = styled.div`
  .ui.pagination.menu .item {
  }

  .ui.pagination.menu .active.item {
  }
`
